import {computed, createApp, ref, watch} from 'vue';
import PRO from '@/pages/login/Login.vue';
import LITE from '@/pages/login/LoginLite.vue';
import TUTOR from '@/pages/login/LoginTutor.vue';
import ErrorComponent from '@components/Error.vue';
import {getSearchParams, injectSvgSprite, nextRequestAnimationFrame} from '@utils/utils.js';
import {loginAPI} from '@/utils/dataProvider/dataProvider.js';
import {commonErrorHandler, initCustomInputState, initHead, loadingWrapper} from "@utils/composables.js";
import {usePopup} from "@components/popup/composable.js";
import {createHead} from "@unhead/vue/client";

const {fetchPageInfo, fetchLogin} = loginAPI;

const popup = usePopup();

let style = '';
let goto = null;

const data = ref({});
const account = initCustomInputState();
const password = initCustomInputState(false);
const autoComplete = ref(true);

const indexBulletinContent = computed(() => {
    const content = data.value?.indexBulletin;
    return content ? content.replaceAll('\n', '<br/>') : '';
})

const validateAccount = () => {
    const text = account.content.value || '';
    const trimmed = text.trim();
    if (!trimmed) {
        account.setError('帳號不可為空')
        return false;
    }
    account.setError('');
    return true;
};

const validatePassword = () => {
    if (!validateAccount()) return false;
    const text = password.content.value || '';
    if (!text) {
        password.setError('密碼不可為空');
        return false;
    }
    // const regex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]+$/;
    // if (!regex.test(text)) {
    //     password.setError('密碼格式不符');
    //     return false;
    // }
    password.setError('');
    return true;
};

const handleLoginEvent = async () => {
    if (!validateAccount() || !validatePassword()) return;
    try {
        const response = await fetchLogin(account.content.value, password.content.value, goto);
        const data = await response.json();
        if (response.ok) {
            if (data.redirectUrl) window.location.href = data.redirectUrl;
        } else {
            password.setError('登入失敗');
        }
    } catch (error) {
        console.error('Login failed', error);
        password.setError('登入失敗');
    }
};

const handleForgotEvent = () => {
    popup.show('forgot')
}

export const useLogin = () => {
    initHead({title: data.value?.team?.displayName})
    watch(account.content, validateAccount);
    watch(password.content, validatePassword);
    return {
        data,
        account,
        password,
        autoComplete,
        indexBulletinContent,
        handleLoginEvent,
        handleForgotEvent
    };
};

// init
(async () => {
    try {
        popup.clearAll()
        const response = await loadingWrapper(fetchPageInfo)('login')
        const info = await response.json();

        goto = getSearchParams('goto')

        if (info?.redirectUrl) {
            window.location.href = info.redirectUrl;
            return;
        }

        style = info?.team?.loginStyle;
        popup.setStyle(style)

        injectSvgSprite();

        const component = {
            'V2-PRO': PRO,
            'V2-TUTOR': TUTOR,
            'V2-LITE': LITE
        }[style];

        if (!component) throw new Error('Login component not found');

        data.value = info;

        // 卸載舊的 Vue app（如果有）
        const oldApp = document.querySelector('#app');
        if (oldApp?.__vue_app__) {
            oldApp.__vue_app__.unmount();
            oldApp.innerHTML = '';
            await nextRequestAnimationFrame();
        }

        const head = createHead()
        createApp(component)
            .use(head)
            .mount('#app');
    } catch (err) {
        commonErrorHandler(err)
    }
})();
